import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { when } from 'mobx';
import { Modal } from 'react-bootstrap';
import EmailTemplateCreateComponent from './emailtemplate-create-component';

@inject('appStore')
@observer
export default class CreateTemplateModal extends Component {
    constructor(props) {
        super(props);
    
    }

    handleTemplateCreated() {
        appStore.viewStore.hideTemplateDialogModal();
        this.props.appStore.viewStore.openEmailTemplatesPage(); //Reload templates 
    }

    render() {
        return (
            <Modal
            show={appStore.viewStore.createTemplateDialogOpen}
            onHide={appStore.viewStore.hideTemplateDialogModal}
            backdrop="static"
            keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="">Create Template</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <EmailTemplateCreateComponent handleTemplateCreated={this.handleTemplateCreated.bind(this)}/>
                </Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/template/emailtemplate-create-modal.js